import React, { Component } from 'react';
import {Container, Row, Col} from 'reactstrap';
import {Link} from 'react-router-dom';
import { LOGO, SITE_TITLE, FACEBOOK, TWITTER, LINKEDIN,INSTAGRAM, GOOGLE} from '../../../../constants';
import NewsLetter from '../../../Newsletter';
class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="footer">
              <Container>
                <Row>
                    <Col lg={4}>
                        <div className="footer-logo">
                            <Link to="/"><img src={LOGO} alt={SITE_TITLE}/></Link>
                        </div>
                        <h2>AeriTech LLC</h2>
                        <ul>
                            <li><i className="icon-location-pin"></i> Irvine, CA, USA</li>
                            <li><a href="tel: +1 949-345-0787"><i className="icon-phone"></i> +1 (949) 345-0787 </a></li>
                            <li><a href="mailto:admin@aeritech.com"><i className="icon-envelope"></i> admin@aeritech.com</a></li>
                        </ul>
                    </Col>
                    <Col lg={3}>
                        <h2>Other Links</h2>
                        <ul>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/">Our Work</Link></li>
                            <li><Link to="/career">Careers</Link></li>
                        </ul>
                    </Col>
                    <Col lg={5}>
                        <NewsLetter/>
                    </Col>
                </Row>
              </Container>
              <div className="footer-bottom">
                <Container>
                    <div className="footer-content">
                        <p>&copy; Copyright 2019. AeriTech LLC All Rights Reserved</p>
                        <div className="social">
                            <a target='_blank' href={LINKEDIN}><i className="fa fa-linkedin" ></i></a>
                            <a target='_blank' href={FACEBOOK}><i className="fa fa-facebook-f"></i></a>
                            <a target='_blank' href={TWITTER}><i className="fa fa-twitter"></i></a>
                        </div>
                    </div>
                </Container>
              </div>
            </div>
        );
    }
}


export default Footer;
